<p-tabView
  [activeIndex]="activeSubComponent"
  (onChange)="onTabActivated($event)"
  styleClass="bfx-tabview"
>
  <p-tabPanel header="Preferences" styleClass="user-settings-tab-panel">
    <bfx-bmark-summary-settings-preferences #subComponent> </bfx-bmark-summary-settings-preferences>
  </p-tabPanel>
</p-tabView>
